module.exports = __webpack_public_path__ + "static/img/10areaA_06.63db1d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/10areaA_06.png
// module id = 987
// module chunks = 1